import { Component, Input } from "@angular/core";

@Component({
  standalone: false,
    selector: 'mm-condensed-label-group',
    templateUrl: './condensed-label-group.component.html',
    styleUrls: ['./condensed-label-group.component.scss']
})

export class CondensedLabelGroupComponent {
    @Input() title: string;
    @Input() data: string;
    @Input() multilineData: string[];
    @Input() addBottomPadding: boolean = false;
    
    constructor() {}
}